import React, { createContext, useContext, useEffect, useState } from 'react';

export const DEFAULT_RUNTIME_CONFIG = {
  company: {
    name: 'CÔNG TY TNHH BT MALL',
    internationalName: 'MALL BT COMPANY LIMITED',
    shortName: 'MALL BT CO.,LTD',
    taxCode: '2500723314',
    businessType: {
      vi: 'Công ty trách nhiệm hữu hạn ngoài NN',
      en: 'Foreign-invested limited liability company',
      zh: '外商投资有限责任公司',
    },
    mainBusiness: {
      vi: 'Bán buôn vải, hàng may sẵn, giày dép',
      en: 'Wholesale of fabrics, ready-made garments and footwear',
      zh: '面料、成衣和鞋类批发',
    },
    activeDate: '',
    status: {
      vi: 'Đang hoạt động',
      en: 'Active',
      zh: '正常营业',
    },
    representative: 'VŨ THỊ THANH',
    address: {
      vi: 'Số nhà 86, đường Hai Bà Trưng, Phường Phúc Yên, Tỉnh Phú Thọ, Việt Nam',
      en: 'No. 86 Hai Ba Trung Street, Phuc Yen Ward, Phu Tho Province, Vietnam',
      zh: '越南富寿省福安坊二征夫人路86号',
    },
    phone: '0868965519',
    email: 'btmallinfo@gmail.com',
    copyright: {
      vi: 'Bản quyền © 2026 CÔNG TY TNHH BT MALL. Đã đăng ký bản quyền.',
      en: 'Copyright © 2026 MALL BT COMPANY LIMITED. All rights reserved.',
      zh: '版权所有 © 2026 MALL BT COMPANY LIMITED。保留所有权利。',
    },
    logo: '',
  },
  fees: { bankTransfer: 9000, currency: 'VND' },
  order: {
    shippingInstruction: {
      vi: 'Được XEM hàng - Trường hợp TỪ CHỐI: BCP cập nhật chính xác lý do trên phần mềm BCCP để người gửi biết - Các phát sinh khác liên hệ: - Trường hợp không phát được: lưu BCP 07 ngày.',
      en: 'Inspection allowed. If delivery is refused, the courier must enter the exact reason in BCCP so the sender is informed. Contact support for other issues. If delivery fails, retain the parcel at the post office for 7 days.',
      zh: '允许验货。如拒收，快递员须在 BCCP 系统中准确填写原因，以便通知寄件人。其他问题请联系支持；如投递失败，包裹在邮局保留 7 天。',
    },
  },
};

const mergeConfig = config => ({
  ...DEFAULT_RUNTIME_CONFIG,
  ...(config || {}),
  company: { ...DEFAULT_RUNTIME_CONFIG.company, ...((config && config.company) || {}) },
  fees: { ...DEFAULT_RUNTIME_CONFIG.fees, ...((config && config.fees) || {}) },
  order: { ...DEFAULT_RUNTIME_CONFIG.order, ...((config && config.order) || {}) },
});

const RuntimeConfigContext = createContext(DEFAULT_RUNTIME_CONFIG);

export const RuntimeConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(() =>
    mergeConfig(typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ : null),
  );

  useEffect(() => {
    let active = true;
    const configUrl = `${process.env.PUBLIC_URL || ''}/runtime-config.json?t=${Date.now()}`;
    fetch(configUrl, { cache: 'no-store' })
      .then(response => {
        if (!response.ok) throw new Error(`Runtime config HTTP ${response.status}`);
        return response.json();
      })
      .then(value => {
        if (active) setConfig(mergeConfig(value));
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
};

export const useRuntimeConfig = () => useContext(RuntimeConfigContext);

export const withRuntimeConfig = WrappedComponent => props => {
  const runtimeConfig = useRuntimeConfig();
  return <WrappedComponent {...props} runtimeConfig={runtimeConfig} />;
};

export const localizedConfigValue = (value, language) => {
  if (!value || typeof value !== 'object') return value || '';
  return value[language] || value.vi || value.en || '';
};
